import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col col-12" }
const _hoisted_2 = { class: "col py-3 px-4 g-0" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "form-check custom-checkbox pb-1 col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-1 col-12",
  for: "no-contact"
}, " Do Not Contact for CAHPS (When checked, please provide appropiate reason(s).) ", -1 /* HOISTED */)
const _hoisted_6 = {
  key: 0,
  class: "my-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "Reason for no contact for CAHPS", -1 /* HOISTED */)
const _hoisted_8 = { class: "form-check custom-checkbox pb-1 col-12" }
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "d-flex mt-2 bg-white flex-column p-2 pb-4 ms-4 w-90" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "service-required-text-color" }, "Other", -1 /* HOISTED */)
const _hoisted_14 = { class: "my-2 d-flex flex-column" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("small", { style: {"margin-bottom":"-1rem"} }, " Alternate CAHPS Contact (Applicable only when the patient is physically or mentally incapable of completing survey.)", -1 /* HOISTED */)
const _hoisted_16 = { class: "d-flex my-4" }
const _hoisted_17 = { class: "form-check custom-checkbox form-check-inline mt-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "same-as-patient-emergency-contact"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Same as Patient Primary Emergency Contact")
], -1 /* HOISTED */)
const _hoisted_19 = { class: "row px-1" }
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-first-name-add" }, " First Name ", -1 /* HOISTED */)
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-last-name-add" }, " Last Name ", -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-relationship-add" }, " Relationship ", -1 /* HOISTED */)
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-rel-desc" }, " Other ", -1 /* HOISTED */)
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "auth-contact-email-add" }, " Email ", -1 /* HOISTED */)
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { for: "referral-mobile-number-add" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Mobile Phone ")
const _hoisted_37 = { class: "fas fa-question-circle" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "referral-alternate-phone-add" }, " Alternate Phone ", -1 /* HOISTED */)
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Mailing Address")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferralAddressForm = _resolveComponent("ReferralAddressForm")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "CAHPS Survey",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                id: "no-contact",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Contacts.NoContact) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, _ctx.referral.Contacts.NoContact]
              ]),
              _hoisted_5
            ]),
            (_ctx.referral.Contacts.NoContact)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Options, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${option.label}-${option.value}`
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          id: `${option.value}-${option.label}`,
                          value: option.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.Contacts.NoContactReasonCollection) = $event))
                        }, null, 8 /* PROPS */, _hoisted_9), [
                          [_vModelCheckbox, _ctx.referral.Contacts.NoContactReasonCollection]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label ms-1 col-12",
                          for: `${option.value}-${option.label}`
                        }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_10)
                      ]),
                      (option.value === 4 && _ctx.referral.Contacts.NoContactReasonCollection.includes(4))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _hoisted_13,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control w-100",
                                placeholder: "Other Contact Person",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.Contacts.NoContactReasonOther) = $event)),
                                maxlength: "300"
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelText, _ctx.referral.Contacts.NoContactReasonOther]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "same-as-patient-emergency-contact",
                    class: "form-check-input au-target",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.Contacts.SameAsEmergencyContact) = $event)),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.markChapsAsEmergencyContact()))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.referral.Contacts.SameAsEmergencyContact]
                  ]),
                  _hoisted_18
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _withDirectives(_createElementVNode("input", {
                      name: "auth-contact-first-name-add",
                      class: "form-control",
                      maxlength: "50",
                      type: "text",
                      placeholder: "Enter First Name",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.Contacts.PrimaryCahpsContact.FirstName) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.referral.Contacts.PrimaryCahpsContact.FirstName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _withDirectives(_createElementVNode("input", {
                      name: "auth-contact-last-name-add",
                      class: "form-control",
                      maxlength: "50",
                      type: "text",
                      placeholder: "Enter Last Name",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.referral.Contacts.PrimaryCahpsContact.LastName) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.referral.Contacts.PrimaryCahpsContact.LastName]
                    ])
                  ]),
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      name: "auth-contact-relationship-add",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referral.Contacts.PrimaryCahpsContact.RelationOption) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.relation, (relation, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: relation.value
                        }, _toDisplayString(relation.text), 9 /* TEXT, PROPS */, _hoisted_29))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, _ctx.referral.Contacts.PrimaryCahpsContact.RelationOption]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _withDirectives(_createElementVNode("input", {
                      name: "auth-contact-rel-desc",
                      class: "form-control",
                      type: "text",
                      placeholder: "Enter Relationship",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.referral.Contacts.PrimaryCahpsContact.Relationship) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.referral.Contacts.PrimaryCahpsContact.Relationship]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _withDirectives(_createElementVNode("input", {
                      name: "auth-contact-email-add",
                      class: "form-control",
                      maxlength: "50",
                      type: "text",
                      placeholder: "Enter Email",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referral.Contacts.PrimaryCahpsContact.EmailAddress) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.referral.Contacts.PrimaryCahpsContact.EmailAddress]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, [
                      _hoisted_36,
                      _withDirectives(_createElementVNode("i", _hoisted_37, null, 512 /* NEED_PATCH */), [
                        [_directive_tooltip, {
                                                    title: 'For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.'
                                                }]
                      ])
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      name: "referral-mobile-number-add",
                      type: "text",
                      class: "form-control phone-number-input",
                      maxlength: "14",
                      placeholder: "Enter Number",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.referral.Contacts.PrimaryCahpsContact.PrimaryPhone) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_directive_number_only],
                      [_vModelText, _ctx.referral.Contacts.PrimaryCahpsContact.PrimaryPhone]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _withDirectives(_createElementVNode("input", {
                      name: "referral-alternate-phone-add",
                      type: "text",
                      class: "form-control phone-number-input",
                      maxlength: "14",
                      placeholder: "Enter Number",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.referral.Contacts.PrimaryCahpsContact.AlternatePhone) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_directive_number_only],
                      [_vModelText, _ctx.referral.Contacts.PrimaryCahpsContact.AlternatePhone]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_ReferralAddressForm, {
                    address: _ctx.referral.Contacts.PrimaryCahpsContact.Address,
                    zipChanged: _ctx.handleZipChange,
                    addressType: "PrimaryCahpsContact",
                    "county-data": _ctx.chapsCountyData
                  }, null, 8 /* PROPS */, ["address", "zipChanged", "county-data"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}